import Axios from "@/plugins/Axios";

export class AparelhosFaciaisService {
  async listar() {
    const response = await Axios().get("aparelhos-faciais");
    return response.data;
  }

  async atualizar(id, dados) {
    const response = await Axios().put(`aparelhos-faciais/${id}`, dados);
    return response.data;
  }
}

export default new AparelhosFaciaisService();
